import Rellax from 'rellax';

export default class {
    constructor(){
        
        const rellax = new Rellax('[data-rellax]')

    }
}
